import { render, staticRenderFns } from "./Gibo.vue?vue&type=template&id=33da4b17&"
import script from "./Gibo.vue?vue&type=script&lang=js&"
export * from "./Gibo.vue?vue&type=script&lang=js&"
import style0 from "./Gibo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports